import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Provider as AlertProvider } from "react-alert";
import AlertTemplate from "react-alert-template-mui";
import "react-toastify/dist/ReactToastify.css";
import "./global.css";
import { Toaster } from "./components/ui/toaster";

const options = {
  timeout: 8000,
};

ReactDOM.render(
  <React.StrictMode>
    <AlertProvider template={AlertTemplate} {...options}>
      <App />

      <Toaster />
    </AlertProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
